module.exports = __webpack_public_path__ + "static/media/homedecore.afdbe1c6.png";